import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { RiBox3Fill } from "react-icons/ri";
import { GoGraph } from "react-icons/go";
import DashboardIcon from "@mui/icons-material/Dashboard";

import { Avatar } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import NotFound from "../../components/not-found/NotFound";
import { useSearchParams } from "react-router-dom";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import Pagination from "react-js-pagination";
import { getDashboardListApi } from "../../services/dashboard";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import { DatePicker, searchDateFormat } from "../../components/Form";
import toast from "react-hot-toast";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;

  const [todayBidList, setTodayBidList] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [total, setTotal] = useState(0);
  const [datas, setData] = useState({});

  const [startDateSearch, setStartDateSearch] = useState("");
  const [endDateSearch, setEndDateSearch] = useState("");
  const [filterType, setFilterType] = useState("");

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setStartDateSearch("");
    setEndDateSearch("");
  };
  //-----------Revenue-Chart------------------
  // const [chartData, setChartData] = useState({
  //   series: [
  //     {
  //       name: "series-1",
  //       data: [30, 80, 60, 90, 60, 40, 98, 26, 34, 89, 21, 90, 67, 100],
  //     },
  //   ],
  //   options: {
  //     xaxis: {
  //       categories: [
  //         "week1",
  //         "week2",
  //         "week3",
  //         "week4",
  //         "week5",
  //         "week6",
  //         "week7",
  //         "week8",
  //         "week9",
  //         "week10",
  //         "week11",
  //         "week12",
  //         "week13",
  //         "week14",
  //       ],
  //     },
  //     chart: {
  //       type: "area",
  //       stacked: false,
  //       height: 350,
  //       zoom: {
  //         type: "x",
  //         enabled: true,
  //         autoScaleYaxis: true,
  //       },
  //       toolbar: {
  //         autoSelected: "zoom",
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false,
  //     },
  //     markers: {
  //       size: 1,
  //     },
  //     title: {
  //       text: "Revenue Details",
  //       align: "left",
  //     },
  //     fill: {
  //       type: "gradient",
  //       gradient: {
  //         shadeIntensity: 1,
  //         inverseColors: false,
  //         opacityFrom: 0.5,
  //         opacityTo: 0,
  //         stops: [0, 90, 100],
  //       },
  //     },
  //     yaxis: {
  //       labels: {
  //         formatter: function (val) {
  //           return `${val}%`;
  //         },
  //       },
  //       //  title: {
  //       //    text: 'Price'
  //       //  },
  //     },
  //     stroke: {
  //       curve: "smooth", // 'smooth' or 'straight'
  //       width: 1, // Thickness of the line
  //     },
  //     tooltip: {
  //       shared: false,
  //       y: {
  //         formatter: function (val) {
  //           return (val / 1000000).toFixed(0);
  //         },
  //       },
  //     },
  //   },
  // });

  // const [timePeriod, setTimePeriod] = useState("monthly"); // Default to monthly data
  // const [chartData, setChartData] = useState({
  //   labels: [],
  //   datasets: [
  //     {
  //       label: "Total Donation Amount",
  //       data: [],
  //       backgroundColor: "rgba(75, 192, 192, 0.6)",
  //       borderColor: "rgba(75, 192, 192, 1)",
  //       borderWidth: 1,
  //     },
  //     {
  //       label: "Total Subscription Amount",
  //       data: [],
  //       backgroundColor: "rgba(153, 102, 255, 0.6)",
  //       borderColor: "rgba(153, 102, 255, 1)",
  //       borderWidth: 1,
  //     },
  //   ],
  // });
  const [timePeriod, setTimePeriod] = useState("weekly");
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Donation",
        data: [],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Subscription",
        data: [],
        backgroundColor: "rgba(153, 102, 255, 0.6)",
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
      },
    ],
  });

  const data = {
    weekly: {
      productA: [200, 300, 250, 400, 320, 290, 310],
      productB: [150, 250, 200, 350, 270, 240, 290],
      labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    monthly: {
      productA: [1500, 2300, 1800, 2100, 3200, 2800, 3100],
      productB: [1200, 1900, 1600, 2000, 3000, 2500, 2700],
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    },
    yearly: {
      productA: [30000, 36000, 42000, 48000, 54000],
      productB: [28000, 33000, 39000, 45000, 50000],
      labels: ["2020", "2021", "2022", "2023", "2024"],
    },
  };

  const handleTimePeriodChange = (event) => {
    setTimePeriod(event.target.value);
  };

  useEffect(() => {
    // Fetch or compute AI-enhanced data if needed
    // const aiData = fetchAIData();
    // Update chartData with AI data
    // Update chart data based on selected time period
    // const { productA, productB, labels } = data[timePeriod];
    // setChartData({
    //   labels: labels,
    //   datasets: [
    //     {
    //       label: "Donation",
    //       data: productA,
    //       backgroundColor: "rgba(75, 192, 192, 0.6)",
    //       borderColor: "rgba(75, 192, 192, 1)",
    //       borderWidth: 1,
    //     },
    //     {
    //       label: "Subscription",
    //       data: productB,
    //       backgroundColor: "rgba(153, 102, 255, 0.6)",
    //       borderColor: "rgba(153, 102, 255, 1)",
    //       borderWidth: 1,
    //     },
    //   ],
    // });
  }, [timePeriod]);
  // console.log
  //------------------listing-Api----------------------------------
  const fetchBidingList = async () => {
    try {
      setTodayBidList([]);
      showLoader();

      const res = await getDashboardListApi(timePeriod);
      if (res.data.status === 200) {
        // setChartData(res.data?.donationData);
        setData(res?.data);

        const donationData = res.data?.data.donationData ?? [];
        console.log(donationData, "donationData:", res.data?.donationData);

        // Extract labels and data for donation and subscription
        const labels = donationData.map((item) => item.data);
        const donationAmounts = donationData.map(
          (item) => item.totalDonationAmount
        );
        console.log(donationAmounts, "donationAmounts+++++");
        const subscriptionAmounts = donationData.map(
          (item) => item.totalSubscriptionAmount
        );
        console.log(subscriptionAmounts, "subscriptionAmounts+++++");
        // Update chart data
        setChartData({
          labels: labels,
          datasets: [
            {
              label: "Donation",
              data: donationAmounts,
              backgroundColor: "rgba(75, 192, 192, 0.6)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
            {
              label: "Subscription",
              data: subscriptionAmounts,
              backgroundColor: "rgba(153, 102, 255, 0.6)",
              borderColor: "rgba(153, 102, 255, 1)",
              borderWidth: 1,
            },
          ],
        });
        console.log(chartData, "chartdat");
        hideLoader();
      } else {
        setTodayBidList([]);
        setTotal(0);
        hideLoader();
      }
    } catch (e) {
      hideLoader();
      // toast.error(e.message)
    }
  };
  // Function to handle the time period change
  useEffect(() => {
    fetchBidingList();
  }, [timePeriod]);
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">Dashboard</h4>
        </div>

        <div className="row d-flex justify-content-between mt-2">
          <div className="col-3 dashboard_card text-start">
            <div className="row">
              <div className="col-8">
                <p>
                  <b>Total Users</b>
                </p>
                <p className="fs-2">{datas?.data?.totalUser}</p>
              </div>
              <div className="col-4">
                <Avatar
                  sx={{
                    borderRadius: 4,
                    background: "#e5e4ff",
                    width: 55,
                    height: 55,
                  }}
                >
                  <PeopleAltIcon sx={{ color: "#8280FF" }} />
                </Avatar>
              </div>
            </div>
          </div>

          <div className="col-3 dashboard_card text-start">
            <div className="row">
              <div className="col-8">
                <p>
                  <b>Active Users</b>
                </p>
                <p className="fs-2">{datas?.data?.totalActiveUser}</p>
              </div>
              <div className="col-4">
                <Avatar
                  sx={{
                    borderRadius: 4,
                    background: "#ffe4e4",
                    width: 55,
                    height: 55,
                  }}
                >
                  <PeopleAltIcon sx={{ color: "#FF8088" }} />
                </Avatar>
              </div>
            </div>
          </div>

          <div className="col-3 dashboard_card text-start">
            <div className="row">
              <div className="col-8">
                <p>
                  <b>In-active users</b>
                </p>
                <p className="fs-2">{datas?.data?.totalInactiveUser}</p>
              </div>
              <div className="col-4">
                <Avatar
                  sx={{
                    borderRadius: 4,
                    background: "#fff3d6",
                    width: 55,
                    height: 55,
                  }}
                >
                  <RiBox3Fill style={{ color: "#FEC53D", fontSize: 35 }} />
                </Avatar>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {/* -----------Revenue-Chart------------------ */}
          {/* <div className="col-8">
            <div className="dashboard_card">
              <div id="chart ">
                <ReactApexChart
                  options={chartData?.options}
                  series={chartData?.series}
                  type="area"
                  height={350}
                />
              </div>
              <div id="html-dist"></div>
            </div>
          </div> */}

          <div className="col-8">
            {/* <h2>Revenue Bar Graph with Two Bars and Time Filters</h2> */}
            <label htmlFor="timeFilter">Filter by Time Period:</label>
            <select
              id="timeFilter"
              value={timePeriod}
              onChange={handleTimePeriodChange}
            >
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>
            <div>
              <Bar
                data={chartData}
                options={{
                  responsive: true,
                  plugins: { legend: { position: "top" } },
                }}
              />
            </div>
          </div>
          {/* -----------Total-Communities------------------ */}
          <div className="col-4">
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>Total Communities</strong>
                <strong>{datas?.data?.totalCommunity}</strong>
              </p>
            </div>
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>Total Community Member</strong>
                <strong>{datas?.data?.totalCommunityMember}</strong>
              </p>
            </div>
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>Total Requested Community Member</strong>
                <strong>{datas?.data?.totalRequestCommunityMember}</strong>
              </p>
            </div>
            {/* </div> */}
            {/* -----------New-Resources------------------ */}
            <div className="dashboard_card mb-4 py-3">
            
              <p className="d-flex justify-content-between">
                <strong>Total Resources</strong>
                <strong>{datas?.data?.finalTotalResource}</strong>
              </p>
            </div>
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>New Resources</strong>
                <strong>{datas?.data?.totalResource}</strong>
              </p>
            </div>
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>Refer To Admin</strong>
                <strong>{datas?.data?.postsReferToAdminLast7DaysCount}</strong>
              </p>
            </div>
            {/* -----------New-Fund-Requests----------------- */}
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>New Fund Requests</strong>
                <strong>{datas?.data?.totalFundRequest}</strong>
              </p>
            </div>
            <div className="dashboard_card mb-4 py-3">
              <p className="d-flex justify-content-between">
                <strong>New Fund Requests Amount</strong>
                <strong>{datas?.data?.totalFundRequestAmount}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
